import { Box, Card, Stack, Typography } from "@mui/material";
import { CompanyLogo } from "../companyLogo/CompanyLogo";
import { getMediasVariant } from "~/Header/components/TopBar/HeaderCircle";
import { MediasLogo } from "~/Header/components/TopBar/MediasLogo";
import LockIcon from "@mui/icons-material/Lock";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { C_OUTLINE_VARIANT } from "../icon/Colors";

export default function CheckoutHeader() {
  const mediasVariant = getMediasVariant();
  const { t } = useTranslation();

  return (
    <Container>
      <StackStyled className="container">
        <MediasLogo variant={mediasVariant} href={true} />
        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <Typography variant="headlineSmall">{t("checkoutPage.title")}</Typography>
          <LockIcon fontSize={"medium"} />
        </Stack>
        <CompanyLogo />
      </StackStyled>
    </Container>
  );
}

const Container = styled(Card)({
  padding: "24px 0",
  borderRadius: "0px",
  borderWidth: "0px",
  borderBottomWidth: "1px",
  borderColor: C_OUTLINE_VARIANT
});

const StackStyled = styled(Stack)({
  flexDirection: "row",
  height: "48px",
  justifyContent: "space-between",
  alignItems: "center",
});
